const addCustomListenerForCartStatusChange = () => {
  function myObserverFunction(status) {
    if (status === 'fetching') {
      window.isCartFetching = true;
    } else if (window.isCartFetching) {
      window.isCartFetching = false;

      if (wasCodeAddedFromInput) {
        wasCodeAddedFromInput = false;
        setTimeout(scrollToCartBottomPosition, 1000);
      }
    }
  }

  let _status = Rebuy.Cart.status;

  Object.defineProperty(Rebuy.Cart, 'status', {
    get() {
      return _status;
    },
    set(newValue) {
      _status = newValue;
      myObserverFunction(newValue);
    },
    configurable: true,
    enumerable: true,
  });
};

document.addEventListener('rebuy:cart.ready', addCustomListenerForCartStatusChange);

let cartUnlockFallbackTimer = null;
const CART_UNLOCK_FALLBACK_MS = 7500;

const setCartElementsDisabledDependOnCartFetchingStatus = (elements, isDisabled) => {
  isDisabled = isDisabled || window.isCartFetching || quickBuyLoadingCount > 0;
  if (isDisabled) {
    // Start once per lock. Vue mutations and repeated fetching updates must not extend it.
    if (cartUnlockFallbackTimer === null) {
      cartUnlockFallbackTimer = setTimeout(() => {
        cartUnlockFallbackTimer = null;
        quickBuyLoadingCount = 0;
        quickBuyCartObserver.disconnect();
        // The setter releases all current controls, including nodes replaced by Vue.
        window.isCartFetching = false;
      }, CART_UNLOCK_FALLBACK_MS);
    }
    elements.forEach((el) => {
      if (el.getAttribute('data-do-not-unblock') === 'true') return;
      if (!el.hasAttribute('disabled')) el.setAttribute('disabled', 'disabled');
    });
  } else {
    clearTimeout(cartUnlockFallbackTimer);
    cartUnlockFallbackTimer = null;
    elements.forEach((el) => {
      if (el.getAttribute('data-do-not-unblock') === 'true') return;
      el.removeAttribute('disabled');
    });
  }
};

const blockCartActions = () => {
  const onChangeItems = document.querySelectorAll(`[data-cart-blocking="onchange"]`);
  const onClickItems = document.querySelectorAll(`[data-cart-blocking="onclick"]`);

  const elements = [...onChangeItems, ...onClickItems];

  onChangeItems.forEach((item) => {
    item.onchange = () => setCartElementsDisabledDependOnCartFetchingStatus(elements, true);
  });
  onClickItems.forEach((item) => {
    const prev = item.ondblclick;
    item.onclick = () => {
      setCartElementsDisabledDependOnCartFetchingStatus(elements, true);
      if (prev && typeof prev === 'function') prev();
    };
  });
  if (window.isCartFetching || quickBuyLoadingCount > 0) {
    setCartElementsDisabledDependOnCartFetchingStatus(document.querySelectorAll('[data-cart-blocking]'), true);
  }
};
const blockCartActionsTimeout = () => setTimeout(blockCartActions, 350);

let quickBuyLoadingCount = 0;
const quickBuyCartObserver = new MutationObserver(() => {
  if (quickBuyLoadingCount === 0) return;
  setCartElementsDisabledDependOnCartFetchingStatus(document.querySelectorAll('[data-cart-blocking]'), true);
});

document.addEventListener('quick-buy:loading', (event) => {
  quickBuyLoadingCount = Math.max(0, quickBuyLoadingCount + (event.detail.loading ? 1 : -1));
  if (quickBuyLoadingCount > 0) {
    quickBuyCartObserver.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'data-cart-blocking'],
    });
  } else {
    quickBuyCartObserver.disconnect();
  }
  setCartElementsDisabledDependOnCartFetchingStatus(document.querySelectorAll('[data-cart-blocking]'), false);
});

let _isCartFetching = window.isCartFetching;
Object.defineProperty(window, 'isCartFetching', {
  get() {
    return _isCartFetching;
  },
  set(value) {
    _isCartFetching = value;
    const elements = document.querySelectorAll(`[data-cart-blocking]`);
    setCartElementsDisabledDependOnCartFetchingStatus(elements, value);
  },
});

document.addEventListener('rebuy:cart.unblockElements', () => {
  const elements = document.querySelectorAll(`[data-cart-blocking]`);
  setCartElementsDisabledDependOnCartFetchingStatus(elements, false);
});

document.addEventListener('rebuy:smartcart.ready', blockCartActionsTimeout);
document.addEventListener('rebuy:cart.change', blockCartActionsTimeout);
document.addEventListener('rebuy:cart.enriched', blockCartActionsTimeout);
